
import Vue from 'vue'
import Meta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import 'chota'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(Meta)
Vue.use(VueClipboard)

new Vue({
  render: h => h(App)
}).$mount('#app')
